import Vue from 'vue'
import VueRouter from 'vue-router'
import modules from './modules'

const routes = [
    ...modules,
    {
        path: '*',
        name: 'not-found',
        meta: {
            title: 'not-found',
        },
        component: () => import('@/view/notFound')
    },
]
const router = new VueRouter({
    routes
})

Vue.use(VueRouter)
export default router
